import { render, staticRenderFns } from "./MyStatistics.vue?vue&type=template&id=44913092&"
import script from "./MyStatistics.vue?vue&type=script&lang=js&"
export * from "./MyStatistics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports